module.exports = __webpack_public_path__ + "img/bg.939d4627.jpg";